export function safeParseNumber(value: string | number | null | undefined): number | undefined
export function safeParseNumber(value: string | number | null | undefined, fallbackValue: number): number
export function safeParseNumber(value?: string | number | null, fallbackValue?: number): number | undefined {
  if (value === undefined || value === null || value === '') {
    return fallbackValue
  }
  const parsed = Number.parseFloat(String(value).replace(',', '.'))
  return Number.isNaN(parsed) ? fallbackValue : parsed
}

export const parseNumber = <T extends number>(
  value: string | number | undefined | null,
  fallbackValue?: T,
): T | number => {
  if (value === undefined || value === null) {
    return fallbackValue as never
  }
  const parsed = Number(value)
  return (Number.isNaN(parsed) ? fallbackValue : parsed) as never
}

export const prefixZero = (value?: number | string | null, length = 8) => {
  if (!value) {
    return value
  }
  return value.toString().padStart(length, '0')
}

export const formatPZN = (value?: string | number | null) => {
  return prefixZero(value, 8)
}

export const normalizePhoneNumber = (value?: string | null): string | undefined => {
  if (!value) {
    return undefined
  }
  // Check if the first character is a plus sign
  const hasPlus = value.charAt(0) === '+'
  // Remove all non-numeric characters
  let normalized = value.replace(/\D/g, '')
  // If the original string started with a plus, add it back at the beginning
  if (hasPlus) {
    normalized = `+${normalized}`
  }
  return normalized
}

export const normalizeFaxNumber = (value?: string | null): string | undefined => {
  const normalized = normalizePhoneNumber(value)
  if (!normalized) {
    return normalized
  }
  return `${normalized}@faxmaker.com`
}

/**
 * Formats an amount in cents to a localized currency string
 * @param amount The amount in cents (e.g., 1299 for €12.99)
 * @param currency The currency code (e.g., 'EUR', 'USD')
 * @param locale The locale for formatting (defaults to 'de-DE')
 * @returns A formatted currency string
 */
export function formatAmount(amount?: number | null, currency = 'EUR', locale = 'de-DE'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format((amount ?? 0) / 100)
}
